import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoF = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 75,
	height: 18,
	viewBox: "0 0 75 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.2735 0H13.3496V3.92358H17.2735V0Z",
			fill: "#FFA245"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.14887 9.54557C4.85437 9.30287 4.20712 9.10062 4.20712 8.53433C4.20712 8.00849 4.85437 7.68489 5.74433 7.68489C7.2411 7.68489 8.6165 8.33208 9.34466 9.01972L10.8414 6.43096C9.50648 5.46018 7.76699 4.81299 5.70388 4.81299C2.30582 4.81299 0.444974 6.71411 0.444974 8.85792C0.444974 11.9725 3.39805 12.4175 5.50161 12.7815C6.75566 12.9838 7.60518 13.2264 7.60518 13.8332C7.60518 14.359 7.11974 14.7635 5.9466 14.7635C4.49029 14.7635 2.54855 13.9545 1.61812 13.1456L0 15.8557C1.2945 16.9882 3.55987 17.7568 5.74433 17.7568C9.30421 17.7568 11.3673 16.0175 11.3673 13.6714C11.3673 10.4354 8.25243 9.90961 6.14887 9.54557Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.2735 5.13672H13.3496V17.4333H17.2735V5.13672Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.8418 4.85449C33.9 4.85449 32.2819 5.98707 31.5942 7.03875C31.0683 5.58258 29.8547 4.85449 28.1153 4.85449C26.1735 4.85449 24.5958 5.94662 24.07 6.67471V5.17808H20.146V17.4747H24.07V9.50616C24.4745 8.98032 25.2026 8.29268 26.2544 8.29268C27.468 8.29268 27.8725 9.02077 27.8725 9.95111V17.4342H31.7965V9.46571C32.1606 8.93987 32.9292 8.25223 34.0214 8.25223C35.1945 8.25223 35.6395 8.98032 35.6395 9.91065V17.3938H39.523V8.49493C39.5635 6.02752 38.1072 4.85449 35.8418 4.85449Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.1134 0H56.1895V17.4337H60.1134V0Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.0003 11.6904C75.0003 7.52414 72.3304 4.85449 68.6896 4.85449C64.8466 4.85449 62.1362 7.72639 62.1362 11.2859C62.1362 15.2904 65.0489 17.7578 68.8515 17.7578C70.7528 17.7578 72.7754 17.232 73.989 16.1398L72.3304 13.7129C71.6427 14.3196 70.4291 14.7646 69.3369 14.7646C67.5165 14.7646 66.4243 13.7129 66.222 12.5803H75.0003V11.6904ZM66.1815 9.99154C66.3434 9.10166 66.9906 7.88819 68.6896 7.88819C70.51 7.88819 71.1168 9.14211 71.2382 9.99154H66.1815Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.0179 4.8535C47.1279 4.8535 46.2784 5.05575 45.4693 5.37934V0.0400391H41.5454V11.2849C41.5454 14.8445 44.4176 17.7568 48.0179 17.7568C51.5778 17.7568 54.4904 14.8849 54.4904 11.2849C54.4904 7.68495 51.5778 4.8535 48.0179 4.8535ZM48.0179 13.8332C46.6021 13.8332 45.4693 12.7007 45.4693 11.2849C45.4693 9.86922 46.6021 8.73664 48.0179 8.73664C49.4338 8.73664 50.5665 9.86922 50.5665 11.2849C50.5665 12.7007 49.3933 13.8332 48.0179 13.8332Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.14887 9.54557C4.85437 9.30287 4.20712 9.10062 4.20712 8.53433C4.20712 8.00849 4.85437 7.68489 5.74433 7.68489C7.2411 7.68489 8.6165 8.33208 9.34466 9.01972L10.8414 6.43096C9.50648 5.46018 7.76699 4.81299 5.70388 4.81299C2.30582 4.81299 0.444974 6.71411 0.444974 8.85792C0.444974 11.9725 3.39805 12.4175 5.50161 12.7815C6.75566 12.9838 7.60518 13.2264 7.60518 13.8332C7.60518 14.359 7.11974 14.7635 5.9466 14.7635C4.49029 14.7635 2.54855 13.9545 1.61812 13.1456L0 15.8557C1.2945 16.9882 3.55987 17.7568 5.74433 17.7568C9.30421 17.7568 11.3673 16.0175 11.3673 13.6714C11.3673 10.4354 8.25243 9.90961 6.14887 9.54557Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.2735 5.13672H13.3496V17.4333H17.2735V5.13672Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.8418 4.85449C33.9 4.85449 32.2819 5.98707 31.5942 7.03875C31.0683 5.58258 29.8547 4.85449 28.1153 4.85449C26.1735 4.85449 24.5958 5.94662 24.07 6.67471V5.17808H20.146V17.4747H24.07V9.50616C24.4745 8.98032 25.2026 8.29268 26.2544 8.29268C27.468 8.29268 27.8725 9.02077 27.8725 9.95111V17.4342H31.7965V9.46571C32.1606 8.93987 32.9292 8.25223 34.0214 8.25223C35.1945 8.25223 35.6395 8.98032 35.6395 9.91065V17.3938H39.523V8.49493C39.5635 6.02752 38.1072 4.85449 35.8418 4.85449Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.1134 0H56.1895V17.4337H60.1134V0Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.0003 11.6904C75.0003 7.52414 72.3304 4.85449 68.6896 4.85449C64.8466 4.85449 62.1362 7.72639 62.1362 11.2859C62.1362 15.2904 65.0489 17.7578 68.8515 17.7578C70.7528 17.7578 72.7754 17.232 73.989 16.1398L72.3304 13.7129C71.6427 14.3196 70.4291 14.7646 69.3369 14.7646C67.5165 14.7646 66.4243 13.7129 66.222 12.5803H75.0003V11.6904ZM66.1815 9.99154C66.3434 9.10166 66.9906 7.88819 68.6896 7.88819C70.51 7.88819 71.1168 9.14211 71.2382 9.99154H66.1815Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.0179 4.8535C47.1279 4.8535 46.2784 5.05575 45.4693 5.37934V0.0400391H41.5454V11.2849C41.5454 14.8445 44.4176 17.7568 48.0179 17.7568C51.5778 17.7568 54.4904 14.8849 54.4904 11.2849C54.4904 7.68495 51.5778 4.8535 48.0179 4.8535ZM48.0179 13.8332C46.6021 13.8332 45.4693 12.7007 45.4693 11.2849C45.4693 9.86922 46.6021 8.73664 48.0179 8.73664C49.4338 8.73664 50.5665 9.86922 50.5665 11.2849C50.5665 12.7007 49.3933 13.8332 48.0179 13.8332Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.5453 11.2861V5.74454L39.7249 3.92432L36.9741 6.71533L41.5453 11.2861Z",
			fill: "#FFA245"
		})
	]
});
export default SvgLogoF;
